import React, { useState, useEffect } from 'react';
import { testimonials } from '../../../../data/testimonials';
import './MobileTestimonialsSection.css';

// School assets map connecting testimonials to logos, Scout scenes, and map coordinates
const SCHOOL_ASSETS = {
  'Boston College': {
    logo: '/college_logos/boston_college_logo.png',
    scene: '/college_logos/college_scout/boston_college_scout.png',
    location: 'Chestnut Hill, MA',
    mapX: 88,
    mapY: 34
  },
  'University of San Diego': {
    logo: '/college_logos/university_of_san_diego_logo.png',
    scene: '/college_logos/college_scout/university_of_san_diego_scout.png',
    location: 'San Diego, CA',
    mapX: 8,
    mapY: 56
  },
  'St. Mary\'s College': {
    logo: '/college_logos/st_marys_college_logo.png',
    scene: '/college_logos/college_scout/st_marys_scout.png',
    location: 'Moraga, CA',
    mapX: 8,
    mapY: 46
  },
  'University of Vermont': {
    logo: '/college_logos/university_of_vermont_logo.png',
    scene: '/college_logos/college_scout/university_of_vermont_scout.png',
    location: 'Burlington, VT',
    mapX: 86,
    mapY: 30
  },
  'Rutgers University': {
    logo: '/college_logos/rutgers_university.png',
    scene: '/college_logos/college_scout/rutgers_scout.png',
    location: 'New Brunswick, NJ',
    mapX: 83,
    mapY: 42
  },
  'University of North Carolina': {
    logo: '/college_logos/university_of_north_carolina.png',
    scene: '/college_logos/college_scout/university_of_north_carolina_scout.png',
    location: 'Chapel Hill, NC',
    mapX: 78,
    mapY: 56
  },
  'Xavier University': {
    logo: '/college_logos/xavier_university_logo.png',
    scene: '/college_logos/college_scout/xavier_university_scout.png',
    location: 'Cincinnati, OH',
    mapX: 72,
    mapY: 44
  },
  'Vanderbilt University': {
    logo: '/college_logos/vanderbilt_university_logo.png',
    scene: '/college_logos/college_scout/vanderbilt_scout.png',
    location: 'Nashville, TN',
    mapX: 70,
    mapY: 56
  },
  'University of Portland': {
    logo: '/college_logos/university_of_portland_logo.png',
    scene: '/college_logos/college_scout/university_of_portland_scout.png',
    location: 'Portland, OR',
    mapX: 8,
    mapY: 28
  },
  'Cal Poly': {
    logo: '/college_logos/cal_poly_logo.png',
    scene: '/college_logos/college_scout/cal_poly_scout.png',
    location: 'San Luis Obispo, CA',
    mapX: 7,
    mapY: 50
  }
};

export default function MobileTestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  // Auto-rotate testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((current) => (current + 1) % testimonials.length);
    }, 12000); // 12 seconds per testimonial
    return () => clearInterval(interval);
  }, []);

  // Enrich active testimonial with assets
  const rawTestimonial = testimonials[activeIndex];
  const schoolAssets = SCHOOL_ASSETS[rawTestimonial.school] || {};
  const activeTestimonial = { ...rawTestimonial, ...schoolAssets };

  return (
    <section 
      id="m-testimonials" 
      className="m-testimonials" 
      style={{ 
        backgroundImage: 'url(/other_images/chalkboard.avif)',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}
      aria-live="polite" 
      aria-label="Student testimonials"
    >
      <div className="m-testimonials__container">
        <h2 className="m-testimonials__title">Loved by students everywhere</h2>
        
        {/* US Map Above */}
        <div className="m-testimonials__map">
          <div 
            className="m-testimonials__map-base"
            style={{
              backgroundImage: 'url(/other_images/united_states_outline.png)',
              backgroundPosition: 'center',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat'
            }}
          >
            {/* Current school pin */}
            {activeTestimonial.mapX && activeTestimonial.mapY && (
              <div
                className="m-testimonials__map-pin"
                style={{
                  left: `${activeTestimonial.mapX}%`,
                  top: `${activeTestimonial.mapY}%`,
                }}
              />
            )}
          </div>
        </div>

        <div className="m-testimonials__content">
          {/* Quote Section */}
          <div className="m-testimonials__text">
            {/* Header row: logo + (school name + stars) */}
            <div className="m-testimonials__header">
              <div className="m-testimonials__school-logo">
                {activeTestimonial.logo && (
                  <img
                    src={activeTestimonial.logo}
                    alt={activeTestimonial.school}
                  />
                )}
              </div>

              <div className="m-testimonials__header-text">
                <div className="m-testimonials__school-name">
                  {activeTestimonial.school}
                </div>
                <div className="m-testimonials__stars">
                  ★★★★★
                </div>
              </div>
            </div>

            {/* Quote block with accent */}
            <div className="m-testimonials__quote-block">
              <p className="m-testimonials__quote">
                "{activeTestimonial.quote}"
              </p>
            </div>

            {/* Footer row: name + verified pill */}
            <div className="m-testimonials__footer">
              <div className="m-testimonials__person">
                <div className="m-testimonials__author-name">
                  {activeTestimonial.name}
                </div>
                <div className="m-testimonials__author-school">
                  {activeTestimonial.school}
                </div>
              </div>
              
              {activeTestimonial.verified && (
                <div className="m-testimonials__verified-pill">
                  ✓ Verified
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
